import { createContext, type ReactNode, useContext } from "react";
import { type ApiClient, createApiClient } from "./client.js";

const ApiClientContext = createContext<ApiClient | null>(null);

export function ApiClientProvider(props: {
  readonly client?: ApiClient;
  readonly children: ReactNode;
}) {
  const client = props.client ?? createApiClient();
  return <ApiClientContext.Provider value={client}>{props.children}</ApiClientContext.Provider>;
}

export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error("useApiClient requires ApiClientProvider");
  }
  return client;
}
